import { AxiosResponse } from "axios";
import instance from "../instance";
import {
  ArbitrageInfo,
  CreateOrderInterface,
  OrderDocuments,
  OrderHistory,
  OrdersInterface,
} from "@/core/reatom/state/orders/types";

interface GetOrders {
  limit?: number;
  offset?: number;
  type?: "tu" | "personal" | "project";
}
export const getOrders = async ({
  limit = 100,
  offset = 0,
  type = "tu",
}: GetOrders): Promise<OrdersInterface> => {
  try {
    const res: AxiosResponse<OrdersInterface> = await instance.get(
      `/v1/orders`,
      {
        params: {
          limit,
          offset,
          type,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCurrentOrder = async (
  orderId: number
): Promise<CreateOrderInterface> => {
  try {
    const res: AxiosResponse<CreateOrderInterface> = await instance.get(
      `/v1/orders/${orderId}`
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const createOrder = async (
  cardId: number,
  extra: number[]
): Promise<CreateOrderInterface> => {
  try {
    const extraObject: Record<string, number> = {};

    extra.forEach((value) => {
      extraObject[value.toString()] = 1;
    });
    const res: AxiosResponse<CreateOrderInterface> = await instance.post(
      `/v1/orders/uslugi-freelancera/${cardId}`,
      { extra: extraObject }
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const paymentOrder = async (oid: number): Promise<string> => {
  try {
    const res: AxiosResponse<{ url: string }> = await instance.post(
      `/v1/orders/${oid}/reserve/pay`
    );
    return res.data.url;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const cancelOrder = async (
  oid: number
): Promise<CreateOrderInterface> => {
  try {
    const res: AxiosResponse<CreateOrderInterface> = await instance.post(
      `/v1/orders/${oid}/cancel`
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const doneOrder = async (oid: number): Promise<CreateOrderInterface> => {
  try {
    const res: AxiosResponse<CreateOrderInterface> = await instance.post(
      `/v1/orders/${oid}/done`
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fixOrder = async (oid: number): Promise<CreateOrderInterface> => {
  try {
    const res: AxiosResponse<CreateOrderInterface> = await instance.post(
      `/v1/orders/${oid}/fix`
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const arbitrageOrder = async (
  oid: number,
  message: string
): Promise<ArbitrageInfo> => {
  try {
    const res: AxiosResponse<ArbitrageInfo> = await instance.post(
      `/v1/orders/${oid}/reserve/arbitrage`,
      {
        message,
      }
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getArbitrageInfo = async (oid: number): Promise<ArbitrageInfo> => {
  try {
    const res: AxiosResponse<ArbitrageInfo> = await instance.get(
      `/v1/orders/${oid}/reserve/arbitrage`
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getHistory = async (
  oid: number,
  limit: number = 50
): Promise<OrderHistory> => {
  try {
    const res: AxiosResponse<OrderHistory> = await instance.get(
      `/v1/orders/${oid}/history`,
      {
        params: {
          limit,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getDocuments = async (
  oid: number,
  limit: number = 20
): Promise<OrderDocuments> => {
  try {
    const res: AxiosResponse<OrderDocuments> = await instance.get(
      `/v1/orders/${oid}/reserve/files`,
      {
        params: {
          limit,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
